// Offline-resilient quote submission queue.
// If POST /api/bookings fails on a flaky/slow connection, the payload is saved
// to localStorage and automatically re-sent when the connection returns.
const KEY = 'homego-quote-queue';

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; }
};
const write = (q) => {
  try { localStorage.setItem(KEY, JSON.stringify(q.slice(-10))); } catch (_) { /* storage full */ }
};

export async function postBooking(apiBase, payload, timeoutMs = 12000) {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    return await fetch(`${apiBase}/api/bookings`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctrl.signal,
      keepalive: true,
    });
  } finally {
    clearTimeout(t);
  }
}

export function queueBooking(payload) {
  const q = read();
  q.push({ payload, queuedAt: new Date().toISOString() });
  write(q);
}

let flushing = false;
export async function flushQueue(apiBase) {
  if (flushing) return;
  const q = read();
  if (!q.length) return;
  flushing = true;
  try {
    const remaining = [];
    for (const item of q) {
      try {
        const res = await postBooking(apiBase, item.payload, 15000);
        // 4xx = payload rejected, drop it; network/5xx = keep for retry.
        if (!res.ok && res.status >= 500) remaining.push(item);
      } catch (_) {
        remaining.push(item);
      }
    }
    write(remaining);
  } finally {
    flushing = false;
  }
}

export function initOfflineQueue(apiBase) {
  window.addEventListener('online', () => flushQueue(apiBase));
  flushQueue(apiBase);
}
